// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportTableBg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  overflow: auto;
  position: relative;
}
.reportTableBg .reportTableHeading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.reportTableBg .reportTableHeading .Back {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.reportTableBg .reportTableHeading .Back svg {
  cursor: pointer;
}
.reportTableBg .reportTableHeading .Back svg path {
  fill: var(--AccentColor);
}
.reportTableBg .reportTableHeading .Back span {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
  line-height: 100%;
}
.reportTableBg .reportTableHeading h1 {
  flex: 1 1;
  margin-left: 2rem;
  font-size: 1.25rem;
  color: var(--TextColor);
}
.reportTableBg .reportTableHeading .reportActions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.reportTableBg .reportTableHeading .reportActions select {
  padding: 0.375rem 0.5rem 0.375rem 0.5rem;
  min-width: 7.5rem;
  background: var(--Foreground);
  color: var(--TextColor);
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.reportTableBg .reportTableHeading .reportActions .exportBtn {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  width: max-content;
  padding: 0.3rem 0.6rem;
  border-radius: 0.3rem;
  background-color: var(--AccentColor);
}
.reportTableBg .reportTableHeading .reportActions .exportBtn p {
  color: #ffffff;
  font-size: 0.875rem;
}
.reportTableBg .reportTableHeading .reportActions .exportBtn svg path {
  fill: #ffffff;
}
.reportTableBg .reportTableHeading .reportActions div {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  width: max-content;
  padding: 0.3rem 0.6rem;
  border-radius: 0.3rem;
  background-color: var(--Foreground);
}
.reportTableBg .reportTableHeading .reportActions div:nth-child(3) {
  background-color: var(--AccentColor);
}
.reportTableBg .reportTableHeading .reportActions div:nth-child(3) p {
  color: white;
}
.reportTableBg .reportTableHeading .reportActions div:nth-child(3) svg path {
  fill: white;
}
.reportTableBg .reportTableHeading .reportActions div:nth-child(4) {
  background-color: var(--Invitation);
}
.reportTableBg .reportTableHeading .reportActions div:nth-child(4) p {
  color: var(--AccentColor);
}
.reportTableBg .reportTableHeading .reportActions div svg path {
  fill: var(--AccentColor);
}
.reportTableBg .reportTableHeading .reportActions div p {
  font-size: 0.8rem;
  color: var(--TextColor);
}
.reportTableBg .reportTableContainer {
  flex: 1 1;
  background-color: var(--Foreground);
  border-radius: 0.6rem;
  overflow: auto;
  display: flex;
}
.reportTableBg .reportTableContainer > * {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/Components/Report/ReportTable.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAGN;AAFM;EACE,eAAA;AAIR;AAHQ;EACE,wBAAA;AAKV;AAFM;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAIR;AADI;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAGN;AADI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAGN;AAFM;EACE,wCAAA;EACA,iBAAA;EACA,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AAIR;AAFM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oCAAA;AAIR;AAFQ;EACE,cAAA;EACA,mBAAA;AAIV;AADU;EACE,aAAA;AAGZ;AACM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mCAAA;AACR;AAAQ;EACE,oCAAA;AAEV;AADU;EACE,YAAA;AAGZ;AAAY;EACE,WAAA;AAEd;AAEQ;EACE,mCAAA;AAAV;AACU;EACE,yBAAA;AACZ;AAGU;EACE,wBAAA;AADZ;AAIQ;EACE,iBAAA;EACA,uBAAA;AAFV;AAOE;EACE,SAAA;EACA,mCAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;AALJ;AAMI;EACE,SAAA;AAJN","sourcesContent":[".reportTableBg {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  overflow: auto;\n  position: relative;\n  .reportTableHeading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    .Back {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      svg {\n        cursor: pointer;\n        path {\n          fill: var(--AccentColor);\n        }\n      }\n      span {\n        color: var(--AccentColor);\n        font-size: 1rem;\n        font-weight: 700;\n        line-height: 100%;\n      }\n    }\n    h1 {\n      flex: 1;\n      margin-left: 2rem;\n      font-size: 1.25rem;\n      color: var(--TextColor);\n    }\n    .reportActions {\n      display: flex;\n      align-items: center;\n      gap: 0.6rem;\n      select {\n        padding: 0.375rem 0.5rem 0.375rem 0.5rem;\n        min-width: 7.5rem;\n        background: var(--Foreground);\n        color: var(--TextColor);\n        border: none;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n      }\n      .exportBtn {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 0.3rem;\n        width: max-content;\n        padding: 0.3rem 0.6rem;\n        border-radius: 0.3rem;\n        background-color: var(--AccentColor);\n\n        p {\n          color: #ffffff;\n          font-size: 0.875rem;\n        }\n        svg {\n          path {\n            fill: #ffffff;\n          }\n        }\n      }\n      div {\n        display: flex;\n        align-items: center;\n        gap: 0.3rem;\n        width: max-content;\n        padding: 0.3rem 0.6rem;\n        border-radius: 0.3rem;\n        background-color: var(--Foreground);\n        &:nth-child(3) {\n          background-color: var(--AccentColor);\n          p {\n            color: white;\n          }\n          svg {\n            path {\n              fill: white;\n            }\n          }\n        }\n        &:nth-child(4) {\n          background-color: var(--Invitation);\n          p {\n            color: var(--AccentColor);\n          }\n        }\n        svg {\n          path {\n            fill: var(--AccentColor);\n          }\n        }\n        p {\n          font-size: 0.8rem;\n          color: var(--TextColor);\n        }\n      }\n    }\n  }\n  .reportTableContainer {\n    flex: 1;\n    background-color: var(--Foreground);\n    border-radius: 0.6rem;\n    overflow: auto;\n    display: flex;\n    & > * {\n      flex: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
